module.exports = __webpack_public_path__ + "img/slide5.94d4e66a.png";